import { render, staticRenderFns } from "./Payouts.vue?vue&type=template&id=bb740562&scoped=true&"
import script from "./Payouts.vue?vue&type=script&lang=js&"
export * from "./Payouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb740562",
  null
  
)

export default component.exports